import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=deeea680&scoped=true&"
import script from "./PettyCash.vue?vue&type=script&lang=js&"
export * from "./PettyCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeea680",
  null
  
)

export default component.exports